module.exports = __webpack_public_path__ + "img/gift_top-orange_gift.0d1f15d7.png";